import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { FormattedMessage } from 'react-intl';
import NavigationPrompt from 'react-router-navigation-prompt';

import PropTypes from 'prop-types';

import Loading from '../../dialogs/loading';
import Error from '../../dialogs/Error';
import Alert from '../../dialogs/Alert';

import { bindActionCreators } from 'redux';
import * as actions from '../../../actions/process.home.actions';
import * as actionsforms from '../../../actions/api.form.actions';
import * as actionscatalog from '../../../actions/api.catalog.actions';
import * as actionsBluetooth from '../../../actions/bluetooth.actions';

import Hidden from '@material-ui/core/Hidden';

import Activity from './Activity';
import Form from './Form';

import ActionBar from './ActionBar';
import PanelInfo from '../../labels/PanelInfo';
import AppBar from '../../navbar/MenuAppBar';
import NavBar from '../../navbar/ResponsiveBottomNavigation';

import { HideIcon } from '../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_styles.css';

function toolbar(handleHide, hide) {
    const aux = [];
    aux.push(
        <HideIcon
            disabled
            key={'hide-menu-toolbar'}
            color={!hide ? 'primary' : 'secondary'}
            onClick={handleHide}
        />,
    );
    return aux;
}

class Forms extends React.Component {

    constructor(props) {
        super(props);
        if (!props.instance || parseInt(props.instance.id, 10) !== parseInt(props.params.instance, 10)) {
            props.loadForm(props.params.instance);
        }
        props.setBluetoothUsed(false);
        this.updateTitle(props);

        this.state = {
            hide: false, 
        }
    }

    updateTitle = (props) => {
        const { instance, params } = props;
        if (instance && parseInt(instance.id, 10) === parseInt(params.instance, 10)) {
            const { proceso, tabs } = instance;
            const tab = tabs.find((tab) => params.form === tab.codigo)
            if(tab) {
                this.props.setCurrentWindow(proceso.nombre + " > " + tab.nombre, true);
            }
            else if (proceso) {
                this.props.setCurrentWindow(proceso.nombre, true);
            } else {
                this.props.setCurrentWindow(params.process);
            }
        } else {
            this.props.setCurrentWindow(params.process);
        }
    }

    componentDidMount() {
        const tools = [toolbar(this.handleHide, false)];
        this.props.setTools(tools);

        this.unlisten = this.props.history.listen((location, action) => {
            if (!location.pathname.includes(this.props.params.instance)) {
                this.props.clearInstanceValue();
                this.props.instanceFetchDataSuccess({});
            }
        });
    }

    componentWillUnmount() {
        this.props.setTools([]);
        this.props.setBluetoothUsed(false);
        this.unlisten();
    }

    getSnapshotBeforeUpdate(prevProps, prevState) {
        const { instance } = this.props;
        if(instance && parseInt(this.props.instance.id, 10) === parseInt(this.props.params.instance, 10) && !this.props.params.form) {
            const { tabs } = instance;
            const tab = tabs ? tabs.reduce((find, item) => {
                                        if(!find && item.visible !== false) {
                                            find  = item;
                                        }
                                        return find;
                                    }, undefined)
                            : undefined;
            if(tab && !isMobile) {
                this.props.history.push(this.props.history.location.pathname + "/" + tab.codigo )
            }
                
        }
        return null;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.params.instance !== this.props.params.instance) {
            this.props.clearInstanceValue();
            this.props.loadForm(this.props.params.instance);
            this.props.setBluetoothUsed(false);
        }
        if (prevProps.params.form !== this.props.params.form) {
            this.refs.scroller.scrollTop = 0;
            this.props.setProminentToolBar(true);
        }
        this.updateTitle(this.props);
        return null;
    }

    handleHide = (event) => {
        this.setState({ hide: !this.state.hide });
        const tools = [toolbar(this.handleHide, !this.state.hide)];
        this.props.setTools(tools);
    };

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    handleScroll = (e) => {
        this.props.setProminentToolBar(false);
    };

    render() {
        const { hide } = this.state;
        const {
            showForm,
            instance,
            instance_is_loading,
            instance_has_error,
            instance_changes,
            params,
        } = this.props;
        const { tabs, id, instancia } = instance;
        const editable = instancia && instancia.finalizado === 0;

        const data =
            showForm && params.instance === id && tabs !== undefined
                ? tabs.find((tab) => params.form === tab.codigo)
                : {};

        if (instance_has_error.hasErrored) {
            return <Error open message={instance_has_error.error} handleClose={this.handleBack} />;
        } else if (instance === undefined) {
            return (
                <Error
                    open
                    message={<FormattedMessage id="error_instance_not_found" />}
                    handleClose={this.handleBack}
                />
            );
        } else {
            return (
                <div className={'fullscreen flex_full_column'}>
                    <NavigationPrompt
                        when={(crntLocation, nextLocation) =>
                            instance_changes &&
                            instance_changes.length > 0 &&
                            !nextLocation.pathname.includes(params.instance)
                        }
                    >
                        {({ onConfirm, onCancel }) => (
                            <Alert
                                title="alert_dialog_discard_title"
                                text="alert_dialog_discard_message"
                                open={true}
                                onCancel={onCancel}
                                onConfirm={onConfirm}
                            />
                        )}
                    </NavigationPrompt>
                    {instance_is_loading && <Loading open opacity />}
                    <div className="flex_header">
                        <AppBar id={0} param={this.props.param} back={true} />
                    </div>
                    <div className="flex_full_row ">
                        <Hidden xsDown>
                            <NavBar active={0} />
                        </Hidden>
                        <div className="display_flex flex_full_column overflow_y_scroll">
                            <div className={'flex_full_row overflow_y_scroll bg_ice_blue'}>
                                <div
                                    className={
                                        'flex_40 padding_top_12 shadow_right_only ' +
                                        (showForm ? 'hide' : '')
                                    }
                                    onScroll={this.handleScroll}
                                >
                                    <Activity
                                        info={instancia}
                                        data={tabs}
                                        active={params.form}
                                        params={params}
                                        editable={editable}
                                    />
                                </div>
                                {showForm ? (
                                    <div
                                        id="form"
                                        ref="scroller"
                                        className={
                                            'flex_60 overflow_y_scroll showbar bg_cloudy_blue_30'
                                        }
                                        onScroll={this.handleScroll}
                                    >
                                        <Form
                                            instancia={instancia}
                                            elements={data}
                                            tab={params.form}
                                            hide={hide}
                                            editable={editable}
                                            parentDeactivated={data.desactivado}
                                        />
                                    </div>
                                ) : (
                                        <PanelInfo id={'activities_aux_message'} />
                                    )}
                            </div>
                            <ActionBar
                                id={this.props.params.instance}
                                instance={instance}
                                local={instancia ? instancia.idLocal : undefined}
                                empleado={instancia ? instancia.idTrabajador : undefined}
                            />
                        </div>
                    </div>
                </div>
            );
        }
    }
}

Forms.propTypes = {
    instance: PropTypes.object.isRequired,
    instance_is_loading: PropTypes.bool.isRequired,
    instance_has_error: PropTypes.object.isRequired,
    instance_changes: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => {
    return {
        instance: state.instance,
        instance_is_loading: state.instance_is_loading,
        instance_has_error: state.instance_has_error,
        instance_changes: state.instance_changes,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        Object.assign({}, actions, actionsforms, actionscatalog, actionsBluetooth),
        dispatch,
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Forms));



// WEBPACK FOOTER //
// ./src/components/complex/forms/Index.js